import { Ticket } from "lucide-react";
import { useEffect, useState } from "react";

import BlocoRecolhivel from "./BlocoRecolhivel";
import Chave from "./Chave";

const API_URL = process.env.REACT_APP_BACKEND_URL || "";
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("token") || ""}`, "Content-Type": "application/json" });

// Senha do pedido, uma chave por módulo (pedido do dono, 30/09/2026): loja de
// mercearia/açougue não chama cliente por senha no Balcão; o Totem
// (autoatendimento) pode continuar com a sua. Desligada, o pedido do módulo
// nasce sem senha no servidor (database.senha_ligada_no_modulo) e ela some da
// tela final, dos cupons, de Pedidos e do aviso no WhatsApp.
const MODULOS = [
  { chave: "Balcao", nome: "Balcão" },
  { chave: "Totem", nome: "Totem", detalhe: "autoatendimento: o cliente usa a senha para retirar" },
];
const TODOS = Object.fromEntries(MODULOS.map((m) => [m.chave, true]));

export default function SenhaPreferencias({ toast }) {
  const [modulos, setModulos] = useState(null); // null = carregando
  useEffect(() => {
    fetch(`${API_URL}/api/settings/senha`, { headers: auth(), cache: "no-store" })
      .then((r) => (r.ok ? r.json() : {}))
      .then((d) => setModulos({ ...TODOS, ...(d.modulos || {}) }))
      .catch(() => setModulos(TODOS));
  }, []);

  const alternar = async (m) => {
    const anterior = modulos;
    const novo = !modulos[m.chave];
    setModulos({ ...modulos, [m.chave]: novo });
    try {
      const r = await fetch(`${API_URL}/api/settings/senha`, { method: "PUT", headers: auth(), body: JSON.stringify({ modulos: { [m.chave]: novo } }) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || "Não foi possível salvar.");
      setModulos({ ...TODOS, ...(d.modulos || {}) });
      toast({
        title: `Senha do ${m.nome} ${novo ? "ligada" : "desligada"}`,
        description: novo ? "Os próximos pedidos voltam a receber senha." : "Os próximos pedidos saem sem senha: na tela final, nos cupons e em Pedidos.",
      });
    } catch (e) {
      setModulos(anterior);
      toast({ title: "Erro ao salvar", description: e.message, variant: "destructive" });
    }
  };

  const resumo = !modulos ? "Carregando…"
    : MODULOS.map((m) => `${m.nome}: ${modulos[m.chave] ? "com senha" : "sem senha"}`).join(" · ");
  return (
    <BlocoRecolhivel e2e="card-senha" icone={Ticket} titulo="Senha do pedido" resumo={resumo} carregando={!modulos}>
      <p className="text-sm text-muted-foreground">
        O número que o cliente recebe para ser chamado na retirada. Desligada, a venda sai sem senha: ela não aparece na
        tela final, nos cupons nem em Pedidos. Vale para os pedidos feitos depois da mudança.
      </p>
      <div className="mt-4 grid gap-x-6 sm:grid-cols-2" data-e2e="senha-modulos">
        {MODULOS.map((m) => (
          <div key={m.chave} className="flex items-center justify-between gap-3 py-2 border-t">
            <div className="min-w-0">
              <p className="text-sm font-medium">{m.nome}</p>
              {m.detalhe && <p className="text-xs text-muted-foreground">{m.detalhe}</p>}
            </div>
            <Chave ligado={modulos?.[m.chave]} onAlternar={() => alternar(m)} desabilitado={!modulos} id={`sw-senha-${m.chave}`} />
          </div>
        ))}
      </div>
    </BlocoRecolhivel>
  );
}
